import { ActionType, isAction } from '../../shared/state/index.state';
import { GatewayActions } from './gateway.actions';

export interface GatewayState {
    // availableDevices: MediaDevice;
    readonly sharedNumbers: Array<string>;
}

export const initialGatewayState: GatewayState = {
    sharedNumbers: []
};

// tslint:disable-next-line:only-arrow-functions (AOT required named function - not arrow notation)
export function sharedNumberReducer(state = initialGatewayState, action: ActionType<any>): any {
    if (isAction(action, GatewayActions.GET_SHARED_NUMBERS_SUCCESS)) {
        return {
            ...state,
            sharedNumbers: action.payload
        };
    }

    return state;
}
